import {
  animalsRacingDisciplines,
  disciplineIds,
  esportDisciplines,
  lineFilterToDisciplineCategories,
  vsportDisciplines,
} from '@/config/constants';

export const getDisciplineCategoriesFromLineFilter = (filter: string) => {
  if (!disciplineIds.includes(filter)) {
    return void 0;
  }

  if (animalsRacingDisciplines.has(filter)) {
    return lineFilterToDisciplineCategories.animal_racing;
  }

  if (vsportDisciplines.has(filter)) {
    return lineFilterToDisciplineCategories.virtual_sport;
  }

  if (esportDisciplines.includes(filter)) {
    return lineFilterToDisciplineCategories.esport;
  }

  return lineFilterToDisciplineCategories.sport;
};
